import { Slot } from "@radix-ui/react-slot";
import { cva, type VariantProps } from "class-variance-authority";
import * as React from "react";

import { cn } from "../../lib/utils";

const buttonVariants = cva("btn !text-[#ffffff]", {
  variants: {
    variant: {
      default: "btn-primary",
      secondary: "btn-secondary",
      destructive: "btn-error",
      ghost: "btn-ghost",
      outline: "btn-outline",
      link: "btn-link",
      warning: "btn-warning",
      success: "btn-success",
      info: "btn-info",
    },
    size: {
      default: "",
      xs: "btn-xs",
      sm: "btn-sm",
      lg: "btn-lg",
      icon: "btn-square btn-sm",
    },
    isOutline: {
      true: "btn-outline",
    },
  },
  defaultVariants: { variant: "default", size: "default" },
});

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof buttonVariants> {
  asChild?: boolean;
}

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, variant, size, isOutline, asChild = false, ...props }, ref) => {
    const Comp = asChild ? Slot : "button";
    return (
      <Comp
        className={cn(buttonVariants({ variant, size, isOutline, className }))}
        ref={ref}
        {...props}
      />
    );
  },
);
Button.displayName = "Button";

export { Button, buttonVariants };
